import { TextField, Button, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { store } from "../../redux/store";
import { useState, useEffect } from "react";
import theme from "../../theme";
import { useDispatch, useSelector } from "react-redux";
import { Box } from "@mui/system";
import { setBreadCrumbs } from "../../redux/slices/breadCrumbMeterSlice";

const CreateLora = () => {
  const dispatch = useDispatch();
  const [createLora] = store.useCreateLoraMutation();
  const [name, setName] = useState("");
  const { t } = useTranslation();
  const onNameChange = (e) => {
    setName(e.target.value);
  };
  useEffect(() => {
    dispatch(setBreadCrumbs("lora/create"));
    return () => {
      dispatch(setBreadCrumbs(null));
    };
  }, []);
  const onSubmitClick = () => {
    const attributes = {
      fields: {
        name: name,
        digital_twin_id: window.LORA.toString(),
        class: "lorawan_network_service",
        meter_type: "lora",
        serial_number: name,

        coordinates: {
          coordinates: [0, 0],
          type: "Point",
        },
      },
    };
    createLora({ attributes: attributes, id: window.LORA });
  };
  return (
    <>
      <Typography
        variant="h2"
        sx={{ color: theme?.palette?.primary.main, mb: 4 }}
      >
        {t("create_lora")}
      </Typography>
      <Box>
        <TextField
          value={name}
          onChange={(e) => onNameChange(e)}
          label={t("name")}
          fullWidth
        />
        <Box width={"100%"} display={"flex"} justifyContent={"flex-end"}>
          <Button
            onClick={onSubmitClick}
            variant={window.BUTTON_TYPE}
            sx={{ mt: 2 }}
          >
            {t("create")}
          </Button>
        </Box>
      </Box>
    </>
  );
};
export default CreateLora;
